'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useAccessAccountOrgRolesPermissionsPage } from '#pplx/frontend/apps/ask/organization/hooks/access.js';
import { AccountPage } from '#pplx/frontend/apps/ask/page-components/account/accountRouteMap.js';
import { ProtectedSettingsPageGate } from '#pplx/frontend/apps/ask/settings-ui/ProtectedSettingsPageGate.js';
import { BaseSettingsSidebarTabs } from '#pplx/frontend/apps/ask/settings/config/TabConfigs.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import React from 'react';
import { Redirect, useRoute } from 'wouter';
export const OrgRolesPermissionsPage = Dynamic(async () => {
    const { OrganizationRolesPermissions } = await import('#pplx/frontend/apps/ask/rbac/index.js');
    const Gated = () => {
        const gate = useAccessAccountOrgRolesPermissionsPage();
        return _jsx(ProtectedSettingsPageGate, { state: gate, Authorized: OrganizationRolesPermissions });
    };
    return { default: Gated };
});
export const OrgViewRolePage = Dynamic(async () => {
    const { ViewRolePage } = await import('#pplx/frontend/apps/ask/rbac/index.js');
    const Gated = () => {
        const gate = useAccessAccountOrgRolesPermissionsPage();
        return _jsx(ProtectedSettingsPageGate, { state: gate, Authorized: ViewRolePage });
    };
    return { default: Gated };
});
export const OrgViewGroupPage = Dynamic(async () => {
    const { ViewGroupPage } = await import('#pplx/frontend/apps/ask/rbac/index.js');
    const Gated = () => {
        const gate = useAccessAccountOrgRolesPermissionsPage();
        return _jsx(ProtectedSettingsPageGate, { state: gate, Authorized: ViewGroupPage });
    };
    return { default: Gated };
});
export const RedirectCreditsToUsage = () => (_jsx(Redirect, { to: BaseSettingsSidebarTabs.Credits.href, replace: true }));
export const RedirectProPerksToAccount = () => (_jsx(Redirect, { to: BaseSettingsSidebarTabs.Account.href, replace: true }));
export const RedirectAccountConnectorsToComputer = () => (_jsx(Redirect, { to: "/computer/connectors", replace: true }));
export const RedirectAccountIntegrationsToComputer = () => (_jsx(Redirect, { to: BaseSettingsSidebarTabs.Computer.href, replace: true }));
export const RedirectTasksToNotifications = ({ taskId }) => {
    const [match, params] = useRoute('/account/tasks/:taskId');
    const id = taskId ?? (match ? params?.taskId : undefined);
    const to = id
        ? `${BaseSettingsSidebarTabs.Notifications.href}?taskId=${id}`
        : BaseSettingsSidebarTabs.Notifications.href;
    return _jsx(Redirect, { to: to, replace: true });
};
export const AccountIndexRedirect = () => {
    const pathname = usePathname();
    // Preserve mobile sidebar landing behaviour by rendering the full AccountPage
    // (handles desktop→/account/details redirect itself).
    if (pathname === '/account') {
        return _jsx(AccountPage, {});
    }
    return _jsx(Redirect, { to: "/account" });
};
//# sourceMappingURL=accountRouteMapComponents.js.map